<template>
  <div class="typhoonBody">
    <div id="map"></div>
    <div class="uploadBox">
      <div class="unpTitle">导入数据</div>
      <el-button type="primary" style="margin-top:20px" @click="uploadData" size="mini">上传文件</el-button>
    </div>
    <el-dialog title="提示" :visible.sync="isShowupLoadBox" width="30%">
      <el-upload
        class="upload-demo"
        drag
        action
        :on-change="handleChange"
        :auto-upload="false"
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip"></div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowupLoadBox = false">取 消</el-button>
        <el-button type="primary" @click="isShowupLoadBox = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { MapCreate, legendColor } from "../map/mapImport.js";
import moment from "moment";
import XLSX from "xlsx";
export default {
  data() {
    return {
      map: null,
      isShowupLoadBox: false,
      typhoonListData: [],
      markerLayer: null
    };
  },
  methods: {
    uploadData(){
      if (this.markerLayer != null) {
        this.markerLayer.clearLayers();
        // this.rainLayer=null
      }
      this.isShowupLoadBox = true
    },
    handleChange(file, fileList) {
      this.fileTemp = file.raw;
      if (this.fileTemp) {
        if (
          this.fileTemp.type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          this.fileTemp.type == "application/vnd.ms-excel"
        ) {
          this.importfxx(this.fileTemp);
        } else {
          this.$message({
            type: "warning",
            message: "附件格式错误，请删除后重新上传！"
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请上传附件！"
        });
      }
    },
    importfxx(data) {
      console.log(data);
      let reader = new FileReader();
      let file = data; //拿到第一条数据
      reader.readAsBinaryString(file); // 将文件以二进制形式读入页面
      // console.log(this);  //这里的this指向 vue中的data4
      let _this = this; //把data里的数据赋值给新的变量
      // wb:wordbook 工作表
      reader.addEventListener("load", function(e) {
        console.log(this); //FileReader实例对象
        var data = e.target.result; //读取成功后result中的数据
        var wb = XLSX.read(data, { type: "binary" }); //以base64方法读取 结果

        let sheetName = wb.SheetNames[0]; //是获取Sheets中第一个Sheet的名字
        let sheets = wb.Sheets[sheetName]; //wb.Sheets[Sheet名]获取第一个Sheet的数据
        //将数据解析为json字符串
        let dataList2 = JSON.stringify(XLSX.utils.sheet_to_json(sheets));
        let dataList3 = JSON.parse(dataList2); //讲json转为 数组的格式 看格式所需
        // _this.dataList = dataList3//赋值
        console.log(dataList3);
        _this.typhoonListData = dataList3;
        _this.isShowupLoadBox = false;
        _this.showpathDataTomap();
      });
    },
    showpathDataTomap() {
      let t = this;
      let printList = [];
      this.typhoonListData.map(item => {
        printList.push([item["纬度"], item["经度"]]);
      });
      let polyline = L.polyline(printList, {
        // radius:5,
        fillOpacity: 1,
        fillColor: "#449BEB",
        color: "#449BEB",
        weight: 3
      });
      // let t = this;
      this.markerLayer.addLayer(polyline);
      this.map.map.fitBounds(polyline.getBounds());
      this.typhoonListData.map(item => {
        let mymaker = L.circleMarker([item["纬度"], item["经度"]], {
          radius: 5,
          fillOpacity: 1,
          fillColor: t.getTyphoonPointColor(item["风速（米/秒）"]),
          color: "black",
          weight: 1
        });
        mymaker.on("mouseover", () => {
          // //console.log(2121212);
          L.popup()
            .setLatLng([item["纬度"], item["经度"]])
            .setContent(
              `
          <div>
         <p>到达时间:${moment(
           item["预达时间（年月日时）"],
           "YYYYMMDDHH"
         ).format("YYYY-MM-DD HH:mm:ss")}</p>
          <p>经度:${item["经度"]}</p>
          <p>纬度:${item["纬度"]}</p>
          <p>最大风速:${item["风速（米/秒）"]}m/s</p>
          <p>中心气压:${item["中心气压（百帕）"]}百帕</p>
          <p>七级风圈半径:${item["十级风圈半径（公里）"]}</p>
          <p>十级风圈半径:${item["七级风圈半径（公里）"]}</p>
          </div>
    `
            )
            .openOn(this.map.map);
        });
        this.markerLayer.addLayer(mymaker);
      });
    },
    getTyphoonPointColor(speed) {
      var color;
      if (speed >= 51.0) color = "rgb(219,0,0)";
      else if (speed >= 41.5 && speed < 51.0) color = "rgb(255,0,255)";
      else if (speed >= 32.7 && speed < 41.5) color = "rgb(255,117,0)";
      else if (speed >= 24.5 && speed < 32.7) color = "rgb(255,255,0)";
      else if (speed >= 17.2 && speed < 24.5) color = "rgb(64,151,239)";
      else if (speed < 17.2) color = "rgb(0,141,0)";
      return color;
    },
    //超出最大上传文件数量时的处理方法
    handleExceed() {
      this.$message({
        type: "warning",
        message: "超出最大上传文件数量的限制！"
      });
      return;
    },
    //移除文件的操作方法
    handleRemove(file, fileList) {
      this.fileTemp = null;
    }
  },
  mounted() {
    this.map = new MapCreate();
    this.map.init("map");
    this.markerLayer = L.layerGroup().addTo(this.map.map);
  },
  beforeDestroy(){
    this.map.map.remove()
  }
};
</script>
 
<style>
.typhoonBody {
  width: 100%;
  height: calc(100vh - 60px);
  background-color: aquamarine;
  position: relative;
}
#map {
  width: 100%;
  height: 100%;
}
.uploadBox {
  width: 150px;
  height: 100px;
  position: absolute;
  top: 50px;
  right: 25px;
  background-color: white;
  z-index: 999;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.unpTitle {
  height: 30px;
  width: 100%;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
}
</style>